import React, { type PropsWithChildren } from 'react';
import { StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { backgroundPalettes, type ScanToPayPalette } from '../../utils';

export const ScanToPayTabsContainer = (props: ScanToPayTabsContainerProps) => {
  const { children, palette } = props;

  return (
    <SafeAreaView edges={['bottom']} style={[styles.container, backgroundPalettes[palette]]}>
      {children}
    </SafeAreaView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type ScanToPayTabsContainerProps = {
  children: PropsWithChildren['children'];
  palette: ScanToPayPalette;
};
